export const steps = [
  {
    index: 1,
    id: 'marketplace',
    title: 'Marketplace',
    subTitle: 'Setup Marketplace detail'
  },
  {
    index: 2,
    id: 'details',
    title: 'Details',
    subTitle: 'Setup Order detail'
  },
  {
    index: 3,
    id: 'product',
    title: 'Product',
    subTitle: 'Setup Product detail'
  },
  {
    index: 4,
    id: 'client',
    title: 'Client',
    subTitle: 'Setup Client detail'
  },
  {
    index: 5,
    id: 'shipping',
    title: 'Shipping',
    subTitle: 'Setup Shipping detail'
  }
];

export const marketplaces = [
  {
    id: 1,
    name: 'ebay'
  },
  {
    id: 3,
    name: 'site'
  },
  {
    id: 4,
    name: 'affiliate'
  }
];

export const urgencyTypes = [
  {
    id: 1,
    name: 'Normal'
  },
  {
    id: 2,
    name: 'Urgent'
  }
];

export const accounts = {
  ebay: [
    {
      id: 1,
      name: 'dvinternationaltrading'
    },
    {
      id: 2,
      name: 'vanautosale'
    },
    {
      id: 3,
      name: '2dayEbay'
    }
  ],
  site: [
    {
      id: 1,
      name: '2dayparts.com'
    },
    {
      id: 2,
      name: 'cool'
    },
  ],
  affiliate: [
    {
      id: 1,
      name: 'Billifts'
    },
  ]
};

export const countryList = [
  {
    label: 'USA',
    value: 'US'
  },
  {
    label: 'Canada',
    value: 'CA'
  }
];
